module.exports = __webpack_public_path__ + "img/userimg_man.f593954c.png";